import { Scene, Choice } from "../models";
import { scenes } from "../scenes";

export class Supermarket extends Scene {
  title = "Supermarket";

  async init() {
    this.image = require("@/images/Vincent_Supermarket.png");
    this.audio = null;
    this.description = "";
  }

  get options(): any[] {
    const choices = [
      new Choice("Enter", async () => {
        if (this.state.storylines.infectedWithYogid) {
          this.description = "SONNY YANG: I need to find that SANITIZER!";
          this.audio = require("@/audio/Pandemic-182-Sonny-MP3.mp3")
        } else {
          await this.navigate(scenes.SupermarketInterior());
        }
      }),
      new Choice("Go Left", async () => await this.navigate(scenes.HouseExterior())),
    ];

    if (!this.state.storylines.findSupermarket) {
      choices.push(
        new Choice("Go Right", async () => await this.navigate(scenes.ShibariHQ()))
      );
    } else {
      choices.push(
        new Choice("Go Right", async () => {
          this.audio = require("@/audio/Pandemic_10_Sonny-MP3.mp3");
          this.description = "SONNY YANG: The Supermarket is right there.";
        })
      );
    }
    return choices;
  }
}

export default new Supermarket();
